<div class="service-authorization-skeleton" *ngIf="isServiceAuthorization">
  <div>
    <ul>
      <li *ngFor="let number of [0, 1, 2]">
        <div class="tab-head">
          <ngx-skeleton-loader appearance="circle" [theme]="{ width: '40px', height: '40px', 'background-color': 'var(--secondary-100)' }"> </ngx-skeleton-loader>
          <div class="tab-icon"></div>
          <h3>
            <ngx-skeleton-loader
              [theme]="{
                width: '60px',
                'border-radius': '90px',
                height: '8px',
                'background-color': 'var(--secondary-100)',
                'margin-bottom': '0px',
                'margin-right': '10px'
              }"
            ></ngx-skeleton-loader>
          </h3>
        </div>
      </li>
    </ul>
  </div>
  <div class="ui-g-12 p-zero">
    <div class="service-authorization-row mb-3" *ngFor="let number of [0, 1, 2]">
      <div>
        <ngx-skeleton-loader appearance="circle" [theme]="{ width: '40px', height: '40px', 'background-color': 'var(--secondary-100)' }"> </ngx-skeleton-loader>
      </div>
      <div class="d-grid">
        <ngx-skeleton-loader
          [theme]="{
            width: '120px',
            'border-radius': '90px',
            height: '12px',
            'background-color': 'var(--secondary-100)',
            'margin-bottom': '0px',
            'margin-right': '10px'
          }"
        ></ngx-skeleton-loader>

        <ngx-skeleton-loader
          [theme]="{
            width: '220px',
            'border-radius': '90px',
            height: '8px',
            'background-color': 'var(--secondary-100)',
            'margin-bottom': '0px',
            'margin-right': '10px'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>
